import { render } from "./InvoiceSummary.vue?vue&type=template&id=21e63604"
import script from "./InvoiceSummary.vue?vue&type=script&lang=js"
export * from "./InvoiceSummary.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__